import { Component } from '@angular/core';
import { UpdateAppConfig } from '@app/features/app-content/states/app-configuration.actions';
import { AppConfigurationState } from '@app/features/app-content/states/app-configuration.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-div-radius-settings',
  templateUrl: './div-radius-settings.component.html',
  styleUrl: './div-radius-settings.component.scss',
  standalone: false,
})
export class DivRadiusSettingsComponent {
  @Select(AppConfigurationState.divRadius)
  divRadius$: Observable<number>;

  constructor(private readonly store: Store) {}

  onDivRadiusSelection(radius: number) {
    this.store.dispatch(new UpdateAppConfig(['onglets', '0', 'divRadius'], radius));
  }
}
